import { ControlBarButtonProps, ControlBarButtonStyles, RaiseHandButton } from "@azure/communication-react";
import React, { useCallback } from "react";
import { useCallAdapter } from "../provider";
import { HandLeftFilled } from "@fluentui/react-icons";
import { selectIsHandRaised, usePcpLiveLessonContext } from "../store";

interface RaiseHandButtonWithAdapterProps extends ControlBarButtonProps {
    styles?: ControlBarButtonStyles
}

export function RaiseHandButtonWithAdapter(props: RaiseHandButtonWithAdapterProps): JSX.Element {
    const callAdapter = useCallAdapter();
    const isHandRaised = usePcpLiveLessonContext(selectIsHandRaised);

    const onRenderRaiseHandIcon = (): JSX.Element => (
        <HandLeftFilled color={'white'} fontSize={24} />
      );

    const toggleRaiseHand = useCallback(async (): Promise<void> => {
        if (isHandRaised) {
            await callAdapter.lowerHand();
        } else {
            await callAdapter.raiseHand();
        }
    }, [callAdapter, isHandRaised]);

    return (
        <RaiseHandButton
            styles={props.styles}
            checked={isHandRaised}
            disabled={props.disabled}
            onToggleRaiseHand={toggleRaiseHand}
            onRenderOnIcon={props.onRenderOnIcon ?? onRenderRaiseHandIcon}
            onRenderOffIcon={props.onRenderOffIcon ?? onRenderRaiseHandIcon}
        />
    );
}

